<template>
    <div class="operator-container">
        <md-menu md-direction="bottom-start" md-size="auto" ref="operatorMenu">
            <md-button class="md-icon-button operator-trigger" md-menu-trigger>
                <div class="operator-trigger__icon">{{ selectedOperator }}</div>
            </md-button>

            <md-menu-content class="operator-menu">
                <md-menu-item
                    v-for="option in operatorOptions"
                    :key="option.value"
                    :class="{ 'is-selected': option.value === selectedOperator }"
                    @click="handleSelection(option)"
                >
                    <div class="operator-menu__icon">{{ option.value }}</div>
                </md-menu-item>
            </md-menu-content>
        </md-menu>
    </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import { GeneralMixin, RatesEngineMixin } from '@/mixins';

export default {
    name: 'RuleOperator',
    components: {},
    mixins: [GeneralMixin, RatesEngineMixin],
    props: {
        value: {
            type: String,
            default: () => '='
        }
    },
    data() {
        return {
            operatorOptions: [
                { value: '=' },
                { value: '+' },
                { value: '-' }
            ],
            selectedOperator: null
        };
    },
    created() {
        this.selectedOperator = this.getValidOperator(this.value);
    },
    watch: {
        value(newValue) {
            const nextValue = this.getValidOperator(newValue);
            if (nextValue !== this.selectedOperator) {
                this.selectedOperator = nextValue;
            }
        }
    },
    methods: {
        getDefaultOperator() {
            const fallback = this.operatorOptions[0];
            return fallback ? fallback.value : '=';
        },
        getValidOperator(value) {
            const operator = typeof value === 'string' ? value : this.getDefaultOperator();
            const exists = this.operatorOptions.some((option) => option.value === operator);
            return exists ? operator : this.getDefaultOperator();
        },
        handleSelection(option) {
            this.selectOperator(option);
        },
        selectOperator(operator) {
            this.selectedOperator = operator.value;
            this.$emit('input', operator.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-container {
    display: inline-flex;
}

.operator-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 4px;
    border-radius: 0;
    background: none;
    background-color: transparent !important;
    box-shadow: none;
    border: none;
}

.operator-trigger:hover,
.operator-trigger:focus,
.operator-trigger:active {
    background: none !important;
    background-color: transparent !important;
    color: inherit;
}

.operator-trigger::before,
.operator-trigger::after {
    display: none;
}

.operator-trigger__icon {
    min-width: 28px;
    min-height: 28px;
    color: #686565 !important;
    background: lightgray;
    border-radius: 4px;
    font-size: 20px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.operator-menu {
    min-width: auto;
    padding: 2px;
}

.operator-menu__icon {
    color: #686565 !important;
    font-size: 20px;
    min-width: 28px;
    text-align: center;
}

.md-menu-item {
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    border-radius: 50%;
    background: none !important;
}
</style>